(() => {
  const openModal = (id) => {
    const modal = document.getElementById(id);
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('mwg-modal-open');
    const focusable = modal.querySelector('input, select, button, textarea');
    if (focusable) focusable.focus();
  };

  const closeModal = (modal) => {
    if (!modal) return;
    modal.hidden = true;
    if (!document.querySelector('.mwg-modal:not([hidden])')) {
      document.documentElement.classList.remove('mwg-modal-open');
    }
  };

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-mwg-open-modal]');
    if (openBtn) {
      event.preventDefault();
      openModal(openBtn.getAttribute('data-mwg-open-modal'));
      return;
    }

    const closeBtn = event.target.closest('[data-mwg-close-modal]');
    if (closeBtn) {
      event.preventDefault();
      closeModal(closeBtn.closest('.mwg-modal'));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mwg-modal:not([hidden])').forEach((modal) => closeModal(modal));
  });

  const profileForm = document.getElementById('mwg-edit-profile-form');
  if (profileForm) {
    profileForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const first = (document.getElementById('mwg-profile-first-name')?.value || '').trim();
      const last = (document.getElementById('mwg-profile-last-name')?.value || '').trim();
      const email = (document.getElementById('mwg-profile-email')?.value || '').trim();
      const fullName = [first, last].filter(Boolean).join(' ') || '—';

      const nameEl = document.querySelector('[data-mwg-profile-name]');
      const emailEl = document.querySelector('[data-mwg-profile-email]');
      const subtitle = document.querySelector('.mwg-profile-page__subtitle');
      if (nameEl) nameEl.textContent = fullName;
      if (emailEl && email) emailEl.textContent = email;
      if (subtitle) subtitle.textContent = fullName === '—' ? '' : fullName;

      try {
        localStorage.setItem(
          'mwg_profile_draft',
          JSON.stringify({ first, last, email, updatedAt: Date.now() })
        );
      } catch (err) {
        /* ignore storage errors */
      }

      closeModal(profileForm.closest('.mwg-modal'));
    });
  }

  try {
    const draft = JSON.parse(localStorage.getItem('mwg_profile_draft') || 'null');
    if (draft && typeof draft === 'object') {
      const nameEl = document.querySelector('[data-mwg-profile-name]');
      const emailEl = document.querySelector('[data-mwg-profile-email]');
      const firstInput = document.getElementById('mwg-profile-first-name');
      const lastInput = document.getElementById('mwg-profile-last-name');
      const emailInput = document.getElementById('mwg-profile-email');
      const fullName = [draft.first, draft.last].filter(Boolean).join(' ');
      if (fullName && nameEl) nameEl.textContent = fullName;
      if (draft.email && emailEl) emailEl.textContent = draft.email;
      if (firstInput && draft.first != null) firstInput.value = draft.first;
      if (lastInput && draft.last != null) lastInput.value = draft.last;
      if (emailInput && draft.email) emailInput.value = draft.email;
    }
  } catch (err) {
    /* ignore */
  }

  const marketingToggle = document.getElementById('mwg-marketing-toggle');
  const marketingForm = document.getElementById('mwg-marketing-form');
  if (marketingToggle && marketingForm) {
    marketingToggle.addEventListener('click', () => {
      const isOn = marketingToggle.getAttribute('aria-checked') === 'true';
      const hosted = marketingToggle.getAttribute('data-hosted-profile');

      if (!isOn) {
        marketingToggle.classList.add('is-on');
        marketingToggle.setAttribute('aria-checked', 'true');
        marketingForm.requestSubmit ? marketingForm.requestSubmit() : marketingForm.submit();
        return;
      }

      if (hosted) {
        window.location.href = hosted;
      }
    });
  }
})();
